module.exports = __webpack_public_path__ + "static/media/pin2.970a7748.ico";